@if (preview) {
  <div
    class="flex flex-1 items-center justify-center rounded-md border-2 border-dashed p-2"
  >
    <span class="text-base text-slate-600">{{ label | transloco }}</span>
  </div>
}

@if (!preview) {
  <div class="flex flex-1 flex-col">
    <div>
      <span class="text-sm text-slate-900">
        {{ label | transloco }}
      </span>
    </div>
    <dx-tag-box
      [disabled]="readOnly"
      [value]="tags ?? []"
      [valueExpr]="'id'"
      [displayExpr]="'name'"
      [dataSource]="dxTagConfig.dataSource"
      [searchEnabled]="true"
      [tagTemplate]="dxTagConfig.tagTemplate"
      [acceptCustomValue]="true"
      [placeholder]="'Aggiungi un tag' | transloco"
      [customItemCreateEvent]="''"
      (onValueChanged)="onTagsUpdated($event.value)"
      (onCustomItemCreating)="dxTagConfig.onCustomItemCreating($event)"
    ></dx-tag-box>
  </div>
}
